import { render, staticRenderFns } from "./DomainDetectionSummary.vue?vue&type=template&id=09239b3f&scoped=true"
import script from "./DomainDetectionSummary.vue?vue&type=script&lang=js"
export * from "./DomainDetectionSummary.vue?vue&type=script&lang=js"
import style0 from "./DomainDetectionSummary.vue?vue&type=style&index=0&id=09239b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09239b3f",
  null
  
)

export default component.exports